/**
 * Chunk L2 — Find the work on Invoices (match queue empty / guidance).
 */

import { canShowMatchAction } from './invoiceMatchActionHelpers'

export const MATCH_QUEUE_FIND_WORK_COPY = {
  needsReviewEmpty:
    'Nothing needs your review right now. Upload invoices above, or show all to browse the library.',
  needsReviewGuidance:
    'These invoices need a decision — open Match on a row to link or reconcile.',
  needsReviewCta: 'Match next',
  filteredEmpty: 'No invoices match these filters.',
  libraryEmpty:
    'No invoices or credit notes uploaded yet. Upload them using the button above.',
  archiveFilteredEmpty: 'No archived invoices match these filters.',
  archiveEmpty: 'No archived invoices.',
}

/**
 * Table emptyText for Invoices Active / Archive (+ Needs my review).
 */
export function getInvoicesTableEmptyText({
  isArchiveView = false,
  isNeedsAttentionFilter = false,
  hasActiveFilters = false,
} = {}) {
  if (isArchiveView) {
    return hasActiveFilters
      ? MATCH_QUEUE_FIND_WORK_COPY.archiveFilteredEmpty
      : MATCH_QUEUE_FIND_WORK_COPY.archiveEmpty
  }
  if (isNeedsAttentionFilter) {
    return MATCH_QUEUE_FIND_WORK_COPY.needsReviewEmpty
  }
  if (hasActiveFilters) {
    return MATCH_QUEUE_FIND_WORK_COPY.filteredEmpty
  }
  return MATCH_QUEUE_FIND_WORK_COPY.libraryEmpty
}

/**
 * Banner when Needs my review is on and there are rows to work.
 * Returns null when nothing to guide.
 */
export function getMatchQueueFindWorkGuidance({
  isNeedsAttentionFilter = false,
  visibleRowCount = 0,
} = {}) {
  if (!isNeedsAttentionFilter || Number(visibleRowCount) <= 0) {
    return null
  }
  return {
    sentence: MATCH_QUEUE_FIND_WORK_COPY.needsReviewGuidance,
    ctaLabel: MATCH_QUEUE_FIND_WORK_COPY.needsReviewCta,
  }
}

/** First visible row that can open Match (top of the queue). */
export function pickNextMatchInvoice(rows = []) {
  if (!Array.isArray(rows)) return null
  return rows.find(row => canShowMatchAction(row)) || null
}
